export default __webpack_public_path__ + "static/media/image_02.c3ebe52d.jpg";